import React from 'react';

import cn from 'classnames';
import Link from 'next/link';

import { NEWS_PATHS } from '@constants/index';
import { TabPane, Tabs } from '@element/index';
import I18n from '@utils/i18n';

import { Market } from '../../Market';
import { useAsideHeight } from '../hooks/useAsideHeight'
import { HotNews } from '../HotNews';
import { NewsLayout } from '../Layout/index';

import styles from './index.module.less';

export const ListLayout = (props) => {
  const { recommend, type, children, activeKey, asideTag } = props;
  const { ref: asideRef } = useAsideHeight()
  return (
    <NewsLayout className={styles.layout}>
      <div className={cn(styles.container)}>
        <div className={styles.main}>
          <h1 className={cn(styles.h1, 'Medium')}>{I18n.t('news')}</h1>
          <Tabs type="marketTab" className={styles.tab} activeKey={activeKey}>
            <TabPane
              className={styles.tabPane}
              tab={
                <h3 data-buried="ZX-01" className={styles.h3}>
                  <Link legacyBehavior href={NEWS_PATHS.INDEX}>
                    <a className={cn('Medium')}>{I18n.t('7RrmgNLW')}</a>
                  </Link>
                </h3>
              }
              key="news"
              type="marketTab"
            >
              {type === 'news' ? children : ''}
            </TabPane>
            <TabPane
              className={styles.tabPane}
              tab={
                <h3 className={styles.h3} data-buried="ZX-02">
                  <Link legacyBehavior href={NEWS_PATHS.HIGHLIGHTS}>
                    <a className={cn('Medium')}>{I18n.t('YwtZDqqk')}</a>
                  </Link>
                </h3>
              }
              key="highlights"
              type="marketTab"
            >
              {type === 'highlights' ? children : ''}
            </TabPane>
          </Tabs>
        </div>
        <div className={styles.aside} ref={asideRef}>
          <HotNews recommend={recommend} asideTag={asideTag} />
          <Market />
        </div>
      </div>
    </NewsLayout>
  );
};
